import React from 'react';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';
import { najdarStaysContent } from '../rich-content/najdar-stays-complete-content';

const NajdarStaysDetailPage = () => {
  return <AutomaticPageBuilder content={najdarStaysContent} />;
};

export default NajdarStaysDetailPage;
